import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import "../../css/course-page.css";
import Intrestedinprogram from './intrestedinprogram';


class Certificateusincybercrime extends Component {
    render() {
        return (
            <div>
                
                    <div aria-label="breadcrumb">
                         <ol class="breadcrumb">                          
                            <li class="breadcrumb-item"><Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                            <li class="breadcrumb-item active">Certificate in Cyber Crime Analysis</li>
                        </ol>
                    </div>

                    <section class="course-header bg-blue1" id="course-header">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                                    <h1>Certificate in Cyber Crime Analysis</h1> 
                                    <p>An Introduction to the Cyber World and the Laws that Govern It</p>
                                    <br /><br />
                                    <div class="row">
                                        <button class="pulse-button" type="button" data-toggle="modal"  data-target="#myModalq" onclick="startvideo()"></button>
                                        <p class="Watch-Intro">Watch Intro Video </p>
                                    </div>
                                    <br />
                                    <div class="form-group">
                                    <a href="#apply-now" class="btn btn-md enroll-btn">Enroll Now </a>

                                      
                                        <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                            data-target="#myModal" > Download
                                            brochure</button><br />  <br /> <br />
                                               </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1"></div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                <p>Jointly Delivered by </p>
                                    <ul>
                                        <li><img width="200px"  alt="" src="/assets/images/epn.svg" /></li>
                                        <li><span><img width="200px" alt=""  src="/assets/images/ascl-removebg-preview.png" /></span></li> 
                                    </ul>
                                    <br />
                                </div>
                            </div>
                        </section>
                        <div class="course-main-contains def-z" id="Description">
                            <div class="card">
                                <div class="row contanint-display">
                                    <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                                    <b>What's included : <br />
                                    <i class="fa fa-mobile" ></i> &nbsp;&nbsp;Mobile Support</b>  
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                                    <b><i class="fa fa-comments" ></i>&nbsp; Discussion Forum</b><br />
                                    <b><i class="fa fa-certificate" ></i> &nbsp; Course Certificate</b>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4"    >    
                                    <b><i class="fa fa-question" ></i> &nbsp;&nbsp;&nbsp;Quiz</b><br />
                                    <b><span class="gold"></span> Online Compiler</b>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <section class="def-z">
                            <div class="header" id="myHeader">
                                    <ul>
                                        <li><a href="#Description">Description</a></li>
                                        <li><a href="#Eligibility">Eligibility</a></li>
                                        <li><a href="#Syllabus">Syllabus</a></li>            
                                        <li><a href="#Outcomes">Learning Outcomes</a></li>           
                                        <li><a href="#Reviews">Learner Review </a></li>          
                                        <li><a href="#Instructor">About Instructor</a></li> 
                                        <li class="btn-header cs-dx"><a href="#apply-now">Enroll Now</a></li>                 
                                    </ul>
                            </div>
                            </section>
                            <section class="course-description" id="course-description">
                                <br />
                                <div class="row"  id="Eligibility">
                                    <div class="col-sm-12">
                                        <h3>Description</h3>
                                        <p align="justify">From the privacy of your personal data stored with Aadhar to your online booking of movie tickets. From your child’s Instagram posts to your Demat account.
                                            From the legality of drones to Uber tracking your movements … cyber law governs your entire world. The course aims to create awareness about legal
                                            rights and responsibilities in the emerging world order.</p>
                                    </div>
                                  
                                </div> 
                                    <br />        
                                <h3 class="heading-tab">Who Should Enroll?</h3>
                            
                                <div class="row">
                                    <div class="col-sm-4">
                                        <ul class="highlight-ul">
                                            <li>Law Students</li>
                                            <li>Defence Lawyers and Prosecutors</li>
                                            <li>Judges</li>
                                        </ul>
                                    </div>
                                    <div class="col-sm-4">
                                        <ul class="highlight-ul">
                                            <li>Police Officers</li>
                                            <li>Chartered accountants</li>
                                            <li>Company Secretaries</li>
                                        </ul>
                                    </div>
                                    <div class="col-sm-4">
                                        <ul class="highlight-ul" id="Syllabus">
                                            <li>IT Professionals</li>
                                            <li >Military Personnel</li>
                                            <li>Government Officials</li>
                                        </ul>
                                    </div>
                                </div> 
                            </section>
                            <section class="course-syllabus" id="course-syllabus">
                                <div class="row">
                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10" >
                                        <h3> Syllabus </h3>
                                        <br />
                                        <div class="syl-bg">
                                        <div id="de_syllabus">
                                            <div class="panel-group">
                                                <div class="panel panel-info">
                                                    <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                                        href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                                        <h6 class="panel-title">
                                                            <i class="indicator fa fa-minus"></i> Digital Evidence 
                                                        </h6>
                                                    </div>

                                                    <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                                        data-parent="#de_syllabus">
                                                        <div class="panel-body">
                                                            <ul class="syllabus-ul">
                                                                <li> Digital Evidence (Fundamentals)</li>
                                                                <li> Sources of Digital Evidence – 1 (Internet) </li>
                                                                <li> Sources of Digital Evidence – 2 (Network Traffic) </li>
                                                                <li> Sources of Digital Evidence – 3 (Operating Systems)</li>
                                                                <li> Sources of Digital Evidence – 4 (Files & Applications) </li>
                                                                <li> Sources of Digital Evidence – 5 (Smartphones, Bitcoin and IoT devices)</li>
                                                                <li> ISO standards relating to Digital Evidence </li>
                                                                <li> Digital Evidence – Best Practices and Standard Operating Procedures </li>
                                                                <li> Laws relating to Digital Evidence </li>
                                                                <li> ASCL Case Files </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <div class="panel panel-info">
                                                    <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                                        href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                                        <h6 class="panel-title">
                                                           <i class="indicator fa fa-minus"></i> Internet Investigation
                                                        </h6>
                                                    </div>

                                                    <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                                        data-parent="#de_syllabus">
                                                        <div class="panel-body">
                                                            <ul class="syllabus-ul">
                                                                <li> Internet and World Wide Web Basics</li>
                                                                <li> Cyber Crimes and Hack attacks</li>
                                                                <li> ASCL Case Files</li>
                                                                <li> Tools for Investigators</li>
                                                                <li> Email & Google Investigation</li>
                                                                <li> Browser Investigation</li>
                                                                <li> Log Analysis</li>
                                                                <li> Social Media Investigation</li>
                                                                <li> Cloud Investigation</li>
                                                                <li> Blockchain & Bitcoin Investigation</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>

                                                
                                                <div class="panel panel-info">
                                                    <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                                        href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                                        <h6 class="panel-title">
                                                            <i class="indicator fa fa-minus"></i> Cyber Crime Prosecution and Defence 
                                                        </h6>
                                                    </div>

                                                    <div id="de_syllabus3" class="collapse show" aria-labelledby="de_heading3"
                                                        data-parent="#de_syllabus">
                                                        <div class="panel-body">
                                                            <ul class="syllabus-ul">
                                                                <li> Information Technology Act & other relevant laws</li>
                                                                <li> Judicial, quasi-judicial & investigative framework</li>
                                                                <li> Relevant entities, terms & concepts</li>
                                                                <li> Penalties under Information technology Act</li>
                                                                <li> Offences under the Information technology Act</li>
                                                                <li> Understanding cyber crimes</li>
                                                                <li> Cyber Crime Prosecution & Defence</li>
                                                                <li id="Outcomes"> Cyber Crime Case Law</li>
                                                                <li> Global Cyber Crime Law – 1 (Antigua, Australia, Canada, EU, GCC)</li>
                                                                <li > Global Cyber Crime Law – 2 (Japan, Malaysia, Singapore, UK, USA)</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                            </div> 
                                        </div> 
                                        </div> 
                                        </div> 
                                  </div>
                            
                             </section> 

                             <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <h3>Learning Outcomes</h3>
                                            <ul class="lo-ul">
                                                <li>Master advanced hacking concepts</li>
                                                <li>Manage information security efficiently</li>
                                                <li>Frame security strategies, and utilize them to analyze risks</li>
                                                <li>Assess and troubleshoot issues to support organizational security</li>
                                                <li>Design security architecture and framework for a secure IT operation</li>
                                            </ul>
                                            <br />
                                            <h3>Assessment</h3>
                                            <div class="table-responsive course-batch-schedule"> 
                                                <div class="card">
                                                    <table class="table">
                                                        <thead>
                                                            <tr class="text-center">
                                                        <th >Type</th>
                                                        <th >Weightage %</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="content-size">
                                                    <tr>
                                                        <td >Content</td>
                                                        <td id="Reviews">100%</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        </div>
                                        </div>
                                        <div class="col-sm-6">

                                            <img src="/assets/images/icons/certificate1.png" alt="" />

                                            <p class="img-below-text text-center">Awarded Jointly by The Asian School of Cyber Laws and
                                                edu plus now </p> 
                                        </div>
                                    </div>
                                    <b /><br />
                                </section> 

                                <section class="course-admission-process"> 
                                
                                </section>
                                <Aboutuslearners />
                                  <Aluminicompany />
                                <section class="courses-feesm">
                                <section class="course-fees" id="course-fees">
                                <div class="row box-sh" >
                                    <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                                           <Intrestedinprogram/>
                                        </div>
                                        <div class="vertical-line-fee"> </div>
                                        <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                                            <div class="row">
                                                <div class="col-sm-10"> <br /><br />
                                                    <h5>Features</h5>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 col-sm-12">
                                                <ul class="highlight-ss" >
                                                <li>Complete Coverage Digital Evidence .</li>
                                                <li> Coverage of Internet Investigation Basic.</li>
                                                <li> Coverage of Blockchain & Bitcoin Investigation.</li>
                                                <li> In-depth Coverage of Information Technology Act & Other Relevant Laws.</li>
                                                <li> Hands-on With Case Studies.</li>  
                                                </ul>
                                                </div>
                                                <p>{// eslint-disable-next-line
                                                 }<marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 " > &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                                            </p>   
                                            </div> 
                                            </div>
                                    </div>
                                </section> 
                                </section> 

                                <Whyedu />

                                <section class="course-about-instructor bg-secondary " id="course-about-instructor" >
                                    <div class="row">
                                <div class="col-sm-12">
                                    <h3>
                                    About the Instructor
                                    </h3>
                                    <br />
                                    <div class="about-ist">
                                        <div class="card pd-abt-ist">
                                            <div class="social-instructor">
                                            <img  onerror="this.onerror=null;this.src='https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/default_avatar.jpg';" alt="" src="https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/21_GokulNarayan.jpg" />
                                            </div>
                                            <div class="inst-details">
                                            <h3>Gokul Narayan</h3>
                                                <p>14 Years Of Experience</p>
                                                <br />
                                                <h4>Asian School of Cyber Laws</h4>
                                                <p align="justify">My passion lies in the field of education as a faculty and an entrepreneur. As a faculty member, I implement new methods of learning, enquiry and research amongst students. I design and conduct courses using a wide variety of teaching aids. </p>
                                            <br />
                                            <ul class="course-about-ul">
                                            <li>{// eslint-disable-next-line
                               }<a href="#" target="_blank">
                                                        <i class="fa fa-facebook" target="_blank"></i>
                                                    </a>
                                                </li>
                                                <li >{// eslint-disable-next-line
                               }<a href="#" target="_blank">
                                                        <i class="fa fa-linkedin" target="_blank"></i>
                                                    </a>
                                                </li>
                                                <li >{// eslint-disable-next-line
                               } <a href="#" target="_blank">
                                                        <i class="fa fa-twitter" target="_blank"></i>
                                                    </a>
                                                </li>
                                                <li>{// eslint-disable-next-line
                               }<a href="#" target="_blank">
                                                    <i class="fa fa-instagram" target="_blank"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                </section> 

                                <div class="modal fade" id="myModalq" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div class="modal-dialog  modal-xl" role="document">
                                    <div class="modal-content">
                                        <div class="modal-body">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onclick="stopvideo()">
                                            <span class="colse-icon" aria-hidden="true">&times;</span>
                                            </button>        
                                          
                                            <div class="embed-responsive embed-responsive-21by9">
                                            <video controls="true" class="embed-responsive-item" id="video" >
                                                <source src="https://s3.ap-south-1.amazonaws.com/eduplusnowlive1/course/31/26/video/Introduction.mp4" type="video/mp4" />
                                            </video>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                               

                                <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog" >
                                    <div class="modal-dialog modal-md">

                                        <div class="modal-content">
                                            <div class="modal-header" >
                                                <span class="close" id="close_form"
                                                data-dismiss="modal">&times;</span>
                                                     <br />
                                            </div>
                                            <div class="modal-body" >
                                                <div class="panel panel-default paper-shadow box_detail" >
                                                    <h5 class="text-center "> Download The Course Brochure </h5>
                                                    <form method="post" class="form-row"  onsubmit="return validate()">
                                                    <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                                            required="" autocomplete="on" name="name" id="name" />
                                                        <b>Your email</b><input class="form-control" type="email" required=""
                                                            autocomplete="on" name="emaill" id="emaill" />
                                                        <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                                            type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                                                        <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />
                                                        
                                                        <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                                        <br />
                                                        <div>
                                                            <div class="form-group">
                                                            <div  id="recaptcha" class="g-recaptcha"
                                                                data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                                                <div id="captcha"></div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div class="mob_cb" >

                                                            <div>
                                                            </div><br />
                                                          
                                                            <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)"  id="exd-download" ><i class="icon-download"></i> Brochure</button>
                                                        </div>
                                                           <br />
                                                        
                                                    </form>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                
            </div>
        );
    }
}

export default Certificateusincybercrime;